import { useState } from 'react'
import { api } from '../lib/api.js'

export default function Register({ onLogin, onSwitchToLogin }) {
  const [email, setEmail] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [password, setPassword] = useState('')
  const [acceptTerms, setAcceptTerms] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')

    if (!email.trim() || !displayName.trim() || !password) {
      setError('Bitte alle Felder ausfuellen.')
      return
    }
    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen haben.')
      return
    }
    if (!acceptTerms) {
      setError('Bitte AGB und Datenschutzerklaerung akzeptieren.')
      return
    }

    setLoading(true)
    try {
      const result = await api.register({
        email: email.trim().toLowerCase(),
        displayName: displayName.trim(),
        password
      })
      onLogin(result.token)
    } catch (err) {
      setError(err.message || 'Registrierung fehlgeschlagen')
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit} style={{ maxWidth: 380 }} action="" method="post" autoComplete="on">
        <h1 style={{ fontSize: 22, fontWeight: 600, textAlign: 'center', marginBottom: 4 }}>Konto erstellen</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-muted)', textAlign: 'center', marginBottom: 18 }}>
          Urs — dein KI-Bauassistent
        </p>

        <label style={{ display: 'block', fontSize: 12, color: 'var(--color-text-muted)', marginBottom: 4 }} htmlFor="reg-email">E-Mail</label>
        <input
          id="reg-email"
          name="email"
          type="email"
          className="input"
          placeholder="name@firma.ch"
          value={email}
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
          autoCapitalize="none"
          autoCorrect="off"
          inputMode="email"
          required
          autoFocus
        />

        <label style={{ display: 'block', fontSize: 12, color: 'var(--color-text-muted)', marginTop: 12, marginBottom: 4 }} htmlFor="reg-name">Anzeigename</label>
        <input
          id="reg-name"
          name="name"
          type="text"
          className="input"
          placeholder="Vor- und Nachname"
          value={displayName}
          onChange={e => setDisplayName(e.target.value)}
          autoComplete="name"
          required
        />

        <label style={{ display: 'block', fontSize: 12, color: 'var(--color-text-muted)', marginTop: 12, marginBottom: 4 }} htmlFor="reg-pw">Passwort</label>
        <div style={{ position: 'relative' }}>
          <input
            id="reg-pw"
            name="password"
            type={showPassword ? 'text' : 'password'}
            className="input"
            placeholder="Mindestens 8 Zeichen"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
            style={{ paddingRight: 60 }}
          />
          <button
            type="button"
            onClick={() => setShowPassword(s => !s)}
            style={{
              position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 11, color: 'var(--color-text-muted)', padding: '4px 6px'
            }}
            tabIndex={-1}
          >
            {showPassword ? 'verb.' : 'zeigen'}
          </button>
        </div>

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 16, fontSize: 13, lineHeight: 1.4, cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={acceptTerms}
            onChange={e => setAcceptTerms(e.target.checked)}
            style={{ marginTop: 2, flexShrink: 0 }}
          />
          <span style={{ color: 'var(--color-text-muted)' }}>
            Ich akzeptiere die AGB und die Datenschutzerklaerung.
          </span>
        </label>

        <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 16, width: '100%' }}>
          {loading ? <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> : 'Kostenlos registrieren'}
        </button>

        {error && <p className="login-error" style={{ marginTop: 12 }}>{error}</p>}

        <p style={{ fontSize: 12, color: 'var(--color-text-muted)', textAlign: 'center', marginTop: 16, lineHeight: 1.5 }}>
          Mit der Registrierung legst du ein persoenliches Urs-Konto an.<br/>
          Inhalte (Aufgaben, Termine, Notizen) sind standardmaessig privat.
        </p>

        <p style={{ fontSize: 12, color: 'var(--color-text-muted)', textAlign: 'center', marginTop: 12 }}>
          Schon ein Konto?{' '}
          <a
            href="#"
            onClick={e => { e.preventDefault(); onSwitchToLogin?.() }}
            style={{ color: 'var(--color-primary)' }}
          >Anmelden</a>
        </p>
      </form>
    </div>
  )
}
